import React, { useState } from 'react';
import '../styles/ImageModal.css';

interface ImageModalProps {
  isOpen: boolean;
  images: string[];
  initialIndex: number;
  onClose: () => void;
  productName: string;
}

const ImageModal: React.FC<ImageModalProps> = ({ isOpen, images, initialIndex, onClose, productName }) => {
  const [currentIndex, setCurrentIndex] = useState(initialIndex);

  if (!isOpen) return null;

  const handlePrevious = () => {
    setCurrentIndex((prev) => (prev - 1 + images.length) % images.length);
  };

  const handleNext = () => {
    setCurrentIndex((prev) => (prev + 1) % images.length);
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'ArrowLeft') handlePrevious();
    if (e.key === 'ArrowRight') handleNext();
    if (e.key === 'Escape') onClose();
  };

  return (
    <div className="image-modal-overlay" onClick={onClose} onKeyDown={handleKeyDown} role="dialog" aria-modal="true">
      <div className="image-modal-container" onClick={(e) => e.stopPropagation()}>
        {/* Botão Fechar */}
        <button className="image-modal-close" onClick={onClose} aria-label="Fechar">
          <i className="bi bi-x-lg"></i>
        </button>

        {/* Imagem Principal */}
        <div className="image-modal-content">
          <img
            src={images[currentIndex]}
            alt={`${productName} - Imagem ${currentIndex + 1}`}
            className="image-modal-image"
            loading="lazy"
            decoding="async"
          />
        </div>

        {/* Navegação */}
        {images.length > 1 && (
          <>
            <button className="image-modal-nav image-modal-prev" onClick={handlePrevious} aria-label="Imagem anterior">
              <i className="bi bi-chevron-left"></i>
            </button>
            <button className="image-modal-nav image-modal-next" onClick={handleNext} aria-label="Próxima imagem">
              <i className="bi bi-chevron-right"></i>
            </button>

            {/* Indicadores */}
            <div className="image-modal-indicators">
              {images.map((_, idx) => (
                <button
                  key={idx}
                  className={`image-modal-indicator ${idx === currentIndex ? 'active' : ''}`}
                  onClick={() => setCurrentIndex(idx)}
                  aria-label={`Ir para imagem ${idx + 1}`}
                />
              ))}
            </div>

            {/* Contador */}
            <div className="image-modal-counter">
              {currentIndex + 1} / {images.length}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default ImageModal;
